module.exports = __webpack_public_path__ + "img/empty-budget.cc73ee52.svg";